import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx } from '@emotion/core';
import { Fieldset, Legend } from './styledComponents';
import { getLabel } from './utils';
import { filterProps, isFunction } from '../../../utils';
import { AddressInput } from './components';
var PROPS_TO_FILTER = ['addressMeta', 'addressMetadata', 'city', 'disableAll', 'emptyStateOption', 'legend', 'line1', 'line2', 'loadingRenderProp', 'postalCode', 'postcode', 'renderAfter', 'renderBefore', 'state', 'styleOverrides'];

var Address = props => {
  var {
    addressMetadata,
    legend,
    styleOverrides
  } = props;
  var filteredProps = filterProps(props, PROPS_TO_FILTER);
  var {
    layout,
    strings
  } = addressMetadata;
  var showLoader = !layout.length && isFunction(props.loadingRenderProp);
  return jsx(Fieldset, {
    css: styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.fieldset,
    disabled: props.disableAll,
    role: "group"
  }, Boolean(legend) && jsx(Legend, {
    css: styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.legend,
    role: "heading"
  }, legend), isFunction(props.renderBefore) && props.renderBefore(), Boolean(layout.length) && layout.map(item => {
    var {
      optionalLabel
    } = strings;
    var {
      isRequired,
      name
    } = item;
    var label = strings["".concat(name, "Label")];

    var itemProps = _objectSpread(_objectSpread({
      label: getLabel(label, optionalLabel, isRequired)
    }, props[name]), item);

    if (name === 'state') {
      itemProps.selectOptions = strings.stateList;
      itemProps.emptyOption = {
        enabled: props.emptyStateOption
      };
    }

    return jsx(AddressInput, _extends({
      key: name
    }, styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides[name], filteredProps, itemProps));
  }) || showLoader && props.loadingRenderProp(), isFunction(props.renderAfter) && props.renderAfter());
};

Address.defaultProps = {
  addressMetadata: {
    layout: [],
    strings: {}
  },
  emptyStateOption: true,
  enableAddressAutocompleteSingleLine: false,
  enableDontSeeMyAddressSuggestion: false,
  isMobile: false,
  overrideAddressSuggestionStyle: false,
  styleOverrides: {}
};
export { Address };